/**
 * GUID utility functions for consistent GUID handling across the application
 */

/**
 * Returns an empty GUID (all zeros)
 * @returns {string} Empty GUID string "00000000-0000-0000-0000-000000000000"
 */
export function getEmptyGuid(): string {
	return "00000000-0000-0000-0000-000000000000"
}

/**
 * Generates a new random GUID using crypto.randomUUID()
 * @returns {string} A new random GUID string
 */
export function generateGuid(): string {
	return self.crypto.randomUUID()
}

/**
 * Checks if a GUID is empty (all zeros)
 * @param guid - The GUID string to check
 * @returns {boolean} True if the GUID is empty, false otherwise
 */
export function isEmptyGuid(guid: string): boolean {
	return guid === "00000000-0000-0000-0000-000000000000"
}